import React, { useState } from "react";
import { Link } from "react-router-dom";
import { loginUser } from "../services/auth";
import { useNavigate } from "react-router-dom";



export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const navigate = useNavigate();


  const validate = () => {
    const e = {};
    if (!form.email.trim()) e.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email.";
    if (!form.password) e.password = "Password is required.";
    else if (form.password.length < 6) e.password = "Password must be at least 6 characters.";
    return e;
  };

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setErrors((er) => ({ ...er, [e.target.name]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();

    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    setLoading(true);

    try {
      const res = await loginUser({
        email: form.email,
        password: form.password,
      });

      if (res.success) {
        // Save user
        
        localStorage.setItem("user", JSON.stringify(res.data.user));
        // Save tokens
        // localStorage.setItem("token", res.data.accessToken);
        localStorage.setItem("accessToken", res.data.accessToken);
        if (res.data.refreshToken) {
          localStorage.setItem("refreshToken", res.data.refreshToken);
        }

        // Trigger cart reload across tabs
        window.dispatchEvent(new Event("storage"));

        navigate("/");
      }

      else {
        alert(res.message || "Invalid credentials");
      }

    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }

    setLoading(false);
  };

  return (
    <>
      <style>{css}</style>

      <div className="auth-page">
        <div className="auth-bg" aria-hidden="true" />

        <div className="auth-card">
          {/* Logo */}
          <div className="auth-logo">
            <span className="auth-logo__icon">🌿</span>
            <span className="auth-logo__text">Sanjivani Ayurveda</span>
          </div>

          <h1 className="auth-title">Welcome Back</h1>
          <p className="auth-subtitle">Sign in to continue your wellness journey</p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label className="form-label" htmlFor="email">
                Email Address <span className="form-required">*</span>
              </label>
              <input
                id="email" name="email" type="email"
                className={`form-input${errors.email ? " form-input--error" : ""}`}
                placeholder="you@example.com"
                value={form.email} onChange={handleChange}
                autoComplete="email"
              />
              {errors.email && <span className="form-error">{errors.email}</span>}
            </div>

            <div className="form-group">
              <div className="auth-label-row">
                <label className="form-label" htmlFor="password">
                  Password <span className="form-required">*</span>
                </label>
                {/* <button type="button" className="auth-forgot">Forgot password?</button> */}
              </div>
              <div className="auth-pass-wrap">
                <input
                  id="password" name="password"
                  type={showPass ? "text" : "password"}
                  className={`form-input auth-pass-input${errors.password ? " form-input--error" : ""}`}
                  placeholder="••••••••"
                  value={form.password} onChange={handleChange}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="auth-eye"
                  aria-label={showPass ? "Hide password" : "Show password"}
                  onClick={() => setShowPass((s) => !s)}
                >
                  {showPass ? "🙈" : "👁️"}
                </button>
              </div>
              {errors.password && <span className="form-error">{errors.password}</span>}
            </div>

            <button type="submit" className="btn-primary auth-submit" disabled={loading}>
              {loading ? <span className="auth-spinner" /> : "Sign In ✦"}
            </button>
          </form>

          <p className="auth-switch">
            Don't have an account?{" "}
            <Link to="/signup" className="auth-link">Sign Up</Link>
          </p>
        </div>
      </div>
    </>
  );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');

:root {
  --c-primary:       #2d6a4f;
  --c-primary-light: #40916c;
  --c-primary-dark:  #1b4332;
  --c-accent:        #d4a017;
  --c-bg:            #f9f6f0;
  --c-surface:       #ffffff;
  --c-text:          #1c2b22;
  --c-muted:         #5a7262;
  --c-border:        #d4e6d5;
  --c-error:         #c0392b;
  --f-display:       'Cormorant Garamond', Georgia, serif;
  --f-body:          'Jost', sans-serif;
  --radius:          14px;
  --shadow:          0 4px 24px rgba(27,67,50,.09);
  --shadow-lg:       0 12px 40px rgba(27,67,50,.15);
  --ease:            cubic-bezier(.4,0,.2,1);
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: var(--f-body); background: var(--c-bg); color: var(--c-text); }

.auth-page {
  min-height: 100vh;
  display: flex; align-items: center; justify-content: center;
  padding: 90px 20px;
  position: relative;
}

.auth-bg {
  position: fixed; inset: 0; z-index: 0;
  background:
    linear-gradient(135deg, var(--c-primary-dark) 0%, #1e4d35 40%, var(--c-bg) 100%);
  opacity: .08;
}

.auth-card {
  position: relative; z-index: 1;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: 20px;
  padding: 44px 40px;
  width: 100%; max-width: 440px;
  box-shadow: var(--shadow-lg);
  animation: authIn .45s var(--ease) both;
}

@keyframes authIn {
  from { opacity:0; transform: translateY(22px); }
  to   { opacity:1; transform: none; }
}

.auth-logo {
  display: flex; align-items: center; gap: 10px;
  justify-content: center; margin-bottom: 28px;
}
.auth-logo__icon { font-size: 1.8rem; }
.auth-logo__text {
  font-family: var(--f-display); font-size: 1.2rem; font-weight: 600;
  color: var(--c-primary-dark);
}

.auth-title {
  font-family: var(--f-display); font-size: 2rem; font-weight: 600;
  color: var(--c-primary-dark); text-align: center; margin-bottom: 6px;
}
.auth-subtitle {
  font-size: .88rem; color: var(--c-muted); text-align: center;
  margin-bottom: 30px;
}

.form-group { display: flex; flex-direction: column; margin-bottom: 18px; }
.form-label {
  font-size: .78rem; font-weight: 600; letter-spacing: .07em;
  text-transform: uppercase; color: var(--c-muted); margin-bottom: 7px;
}
.form-required { color: var(--c-error); }
.form-input {
  font-family: var(--f-body); font-size: .9rem;
  padding: 11px 16px; border-radius: 10px;
  border: 1.5px solid var(--c-border);
  background: var(--c-bg); color: var(--c-text);
  outline: none; transition: border-color .22s, box-shadow .22s; width: 100%;
}
.form-input:focus { border-color: var(--c-primary-light); box-shadow: 0 0 0 3px rgba(64,145,108,.15); }
.form-input::placeholder { color: var(--c-muted); }
.form-input--error { border-color: var(--c-error); }
.form-error { font-size: .74rem; color: var(--c-error); margin-top: 5px; }

.auth-label-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 7px; }
.auth-label-row .form-label { margin-bottom: 0; }
.auth-forgot {
  background: none; border: none; cursor: pointer;
  font-family: var(--f-body); font-size: .74rem; color: var(--c-primary-light);
  font-weight: 500; padding: 0;
  transition: color .2s;
}
.auth-forgot:hover { color: var(--c-primary-dark); }

.auth-pass-wrap { position: relative; display: flex; align-items: center; }
.auth-pass-input { padding-right: 44px; }
.auth-eye {
  position: absolute; right: 12px;
  background: none; border: none; cursor: pointer; font-size: 1rem;
  line-height: 1; padding: 4px; border-radius: 4px;
  transition: opacity .2s;
}
.auth-eye:hover { opacity: .7; }

.btn-primary {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  font-family: var(--f-body); font-size: .82rem; font-weight: 600;
  letter-spacing: .07em; text-transform: uppercase;
  padding: 12px 28px; border-radius: 100px; border: none;
  background: var(--c-primary); color: #fff; cursor: pointer;
  transition: background .22s, transform .22s;
}
.btn-primary:hover:not(:disabled) { background: var(--c-primary-dark); transform: translateY(-1px); }
.btn-primary:disabled { opacity: .7; cursor: not-allowed; }

.auth-submit { width: 100%; margin-top: 6px; }

.auth-spinner {
  width: 18px; height: 18px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,.3);
  border-top-color: #fff;
  animation: spin .7s linear infinite;
  display: inline-block;
}
@keyframes spin { to { transform: rotate(360deg); } }

.auth-switch {
  text-align: center; margin-top: 22px;
  font-size: .88rem; color: var(--c-muted);
}
.auth-link {
  color: var(--c-primary); font-weight: 600; text-decoration: none;
  transition: color .2s;
}
.auth-link:hover { color: var(--c-primary-dark); }

@media (max-width: 480px) {
  .auth-card { padding: 30px 22px; }
}
`;
